const alignmentNames = {
  '': 'Vasen',
  center: 'Keskitetty',
  right: 'Oikea',
}

const labelAlignmentPicker = (toolbar) => {
  if (!toolbar) return
  const picker = toolbar.querySelector('span.ql-align.ql-picker')
  if (!picker) return
  picker.removeAttribute('title')
  const label = picker.querySelector('.ql-picker-label')
  if (label) {
    label.setAttribute('aria-label', 'Tekstin tasaus')
    label.setAttribute('title', 'Tekstin tasaus')
  }
  picker.querySelectorAll('.ql-picker-item').forEach((item) => {
    const value = item.getAttribute('data-value') || ''
    const name = alignmentNames[value] || 'Vasen'
    item.setAttribute('aria-label', name)
    item.setAttribute('title', name)
  })
}

export default labelAlignmentPicker
